import React,{Fragment,useEffect} from 'react';
import { RootState} from 'ReduxStore/store'
import { Redirect, Route,useHistory ,withRouter,Link,useParams} from 'react-router-dom';
import { useDispatch,useSelector } from 'react-redux';
import { GetAllExercises} from 'ReduxStore/exercises/Action'
import { useStyles } from 'Components/Reusable/Categories/categories.style';
import category from 'Assets/img/svg/categoriesImage.svg';
import Header from 'Components/Header/Header';
import { categories } from 'Utils/options';
import MenuCard from 'Components/Reusable/Menu/MenuCard';
import { getMilestoneById,getMilestoneByCategories } from 'ReduxStore/milestones/Action'

interface RouteParams {
    id:string
}

const MilestoneDetails  = () => {
  const classes = useStyles();
    const dispatch = useDispatch()

    const params = useParams<RouteParams>();
    //eslint-disable-next-line 
    console.log("Id is",params.id)

    useEffect(() => {

        dispatch(getMilestoneById(params.id))

	  }, []);

    const milestone = useSelector((state:RootState) => state.milestones.milestoneItem);
    return(
        <Fragment>
            <div className="">
          <Header />
          {
              milestone  ? (
                  <div>
                      <h1>{milestone.title}</h1>
                  </div>
              ) : <p>No milestones found for this particular category</p>
          }
        </div>

        </Fragment>
    )
}

export default MilestoneDetails;

